import React from "react";
import Common_Title from "../../common-components/common_title/Common_Title";
import "./Why_Choose_Us.css";

function Why_Choose_Us({ content }) {
  const featuresData = [
    {
      id: 1,
      title: "100%",
      subtitle: "Genuine Medicines",
    },
    {
      id: 2,
      title: "Licensed",
      subtitle: "& Verified Pharmacy",
    },
    {
      id: 3,
      title: "Secure",
      subtitle: "Online Payments",
    },
    {
      id: 4,
      title: "Trusted",
      subtitle: "Healthcare Products",
    },
  ];

  return (
    <section className="why_choose_us">
      <div className="container">
        <Common_Title titleStart="Why choose us" />

        <div className="feature-wrapper ">
          <div className="row">
            {content?.map((item, index) => (
              <div className="col-lg-3 col-md-6 col-6 mb-3">
                <div className="feature-card " key={index}>
                  <span className="card-number">{index + 1}</span>
                  <div className="card_content">
                    <h4 className="card_title">{item.name || ""}</h4>
                    <p className="card_description">{item.subname || ""}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Why_Choose_Us;
